import React from 'react';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import RadioButton from '../Inputs/Radiobutton';
import { SimulatorRoom } from '../../Types/SimulatorRoom';
import clsx from 'clsx';
interface RoomSelectorInterface {
  simulatorRooms: SimulatorRoom[];
  selectedRoom: SimulatorRoom;
  setSelectedRoom: (room: SimulatorRoom) => void;
}
const WallPaperSimulatorRoomSelector = ({
  simulatorRooms,
  selectedRoom,
  setSelectedRoom,
}: RoomSelectorInterface) => {
  return (
    <fieldset className="grid grid-cols-2 gap-2 border-t-gray-100 bg-gray-50 p-4">
      {simulatorRooms.map((room, idx) => (
        <div
          className={clsx(
            'flex items-center justify-between rounded border bg-white p-1.5 pr-3 hover:cursor-pointer',
            selectedRoom.name == room.name
              ? ' border-gray-700'
              : 'border-gray-100'
          )}
          key={room.name + idx}
        >
          <label
            className="flex flex-1 cursor-pointer items-center gap-2"
            htmlFor={room.name}
          >
            <ResponsiveImage
              {...room.roomImage}
              imgProps={{ className: 'w-[40px] h-auto rounded' }}
            />
            <h6 className="flex flex-1 text-h6">{room.name}</h6>
          </label>
          <RadioButton
            id={room.name}
            name="wallpaperSimulator"
            checked={selectedRoom.name == room.name}
            onChange={() => setSelectedRoom(room)}
          />
        </div>
      ))}
    </fieldset>
  );
};

export default WallPaperSimulatorRoomSelector;
